import { render, staticRenderFns } from "./Concept.vue?vue&type=template&id=9366886c"
import script from "./Concept.vue?vue&type=script&lang=ts"
export * from "./Concept.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports